// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3c6ef300a5--wrapper--spaPT","container":"_3c6ef300a5--container--mtPAd","sidebar":"_3c6ef300a5--sidebar--g3ltM","content":"_3c6ef300a5--content--cpk4h"};